const DAY_MS = 24 * 60 * 60 * 1000;

function daysSince(isoDate) {
  if (!isoDate) {
    return null;
  }

  const parsed = new Date(isoDate);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return Math.floor((Date.now() - parsed.getTime()) / DAY_MS);
}

export function getAvailabilityBadge(status) {
  const normalized = String(status || "AVAILABLE").toUpperCase();

  switch (normalized) {
    case "AVAILABLE":
      return { label: "Available", tone: "success" };
    case "PENDING_REVIEW":
      return { label: "Needs Verification", tone: "warning" };
    case "UNAVAILABLE":
      return { label: "Unavailable", tone: "danger" };
    case "UNKNOWN":
    default:
      return { label: "Availability Unknown", tone: "neutral" };
  }
}

export function getFreshnessBadge(lastSeenAt) {
  const days = daysSince(lastSeenAt);

  if (days === null) {
    return { label: "Not yet confirmed", tone: "neutral" };
  }

  if (days <= 0) {
    return { label: "Seen today", tone: "success" };
  }

  if (days <= 2) {
    return { label: `Seen ${days} day${days === 1 ? "" : "s"} ago`, tone: "success" };
  }

  if (days <= 3) {
    return { label: "Recently updated", tone: "medium" };
  }

  if (days <= 7) {
    return { label: "Seen this week", tone: "medium" };
  }

  return { label: "Needs verification", tone: "warning" };
}

export function getSourceCountLabel(activeSourceCount = 0) {
  const count = Number(activeSourceCount) || 0;

  if (count > 1) {
    return `Available from ${count} sources`;
  }

  if (count === 1) {
    return "1 source";
  }

  return "Source pending";
}

export function getSourceTrustBadge(activeSourceCount = 0) {
  const count = Number(activeSourceCount) || 0;

  if (count > 1) {
    return { label: "Multiple sources", tone: "success" };
  }

  if (count === 1) {
    return { label: "Single source", tone: "neutral" };
  }

  return { label: "No active sources", tone: "warning" };
}
